module.exports = __webpack_public_path__ + "img/Total_Consumption.758d70d4.jpg";